module.exports = __webpack_public_path__ + "img/clear.ba8374e0.svg";